import { render, staticRenderFns } from "./ClickToContactInfoComponent.vue?vue&type=template&id=639bf626&scoped=true"
import script from "./ClickToContactInfoComponent.vue?vue&type=script&lang=js"
export * from "./ClickToContactInfoComponent.vue?vue&type=script&lang=js"
import "./ClickToContactInfoComponent.vue?vue&type=style&index=0&id=639bf626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639bf626",
  null
  
)

export default component.exports